import { ApiUrls } from '../nimmsta-commons-module.config';

interface IDataTableModuleConfiguration {
  defaultPageSizeOptions: number[];
  defaultPageSize: number;
  apiUrls: ApiUrls;
}
export abstract class DataTableModuleConfiguration implements IDataTableModuleConfiguration {
  defaultPageSizeOptions: number[];

  defaultPageSize: number;

  apiUrls: ApiUrls;

  constructor(config: IDataTableModuleConfiguration) {
    this.defaultPageSizeOptions = config.defaultPageSizeOptions;
    this.defaultPageSize = config.defaultPageSize;
    this.apiUrls = config.apiUrls;
  }
}
